<template>
<div class="containers">
    <div v-if="!flagSetting">
        <div class="search-area">
            <CAlert
            v-if="success == true"
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
            </CAlert>
            <CAlert
            v-else
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:red;border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
            </CAlert>
            <CRow class="no-gutters">
                <CCol style="padding-right:6px" sm="10">
                    <input type="text" v-model="searchKontrak" placeholder="Nama Perusahaan" class="form-control"/>
                </CCol>
                <CCol style="padding-left:6px" sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6" style="float:left">
                    <img class="mr-4 mt-1" @click="reload()" title="refresh" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:left"/>
                    <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <img class="mr-4 mt-1" style="float:left" :src="moreIcon" width="20px" height="20px"/>
                </CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-if="flagSetting">
        <SettingKontrak :isDetail="flagSetting" :isData="datasDetail" @goDetail="checkDetail" @goUpdate="checkUpdate"/>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableKontrak'
import {DataApi} from "../../../service/DataApi";
import SettingKontrak from './SettingKontrakPerusahaan.vue'

const xlsx = require('json-as-xlsx')

export default {
    components: {
        Tables,
        SettingKontrak
    },
    data() {
        return {
            flagSetting: false,
            datasDetail: [],

            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['Nama Perusahaan', 'Nama Perjanjian', 'Tanggal Cut Off', 'Tanggal Perjanjian', 'Fee Management'],
            dataTd: ['nama', ['namaPerjanjianKontrak', 'nomorPerjanjianKontrak'], ['tanggalCutOffBaukPo', 'tanggalCutOffBaukNonPo'], ['tglMulaiShow', 'tglAkhirShow'], 'feeManagement' ],
            styleTable: ['150px', '200px', '250px', '150px', '100px',],
            classReload: 'reloadOff',
            datas: [],

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchKontrak: '',

            // error
            errorMessage: '',
            flagSearch: false,

            alertMess: '',
            currentAlertCounter: 0,
            success: true,
        }
    },
    computed: {
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchKontrak() {
            this.flagSearch = true
        },
    },
    methods: {
        checkDetail(value) {
            if(!value) {
                this.flagSetting = false
                this.datasDetail = []
            }
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        checkUpdate(value) {
            this.flagSetting = false
            this.datasDetail = []
            this.alertMess = value.resp
            this.currentAlertCounter = 5
            this.success = value.suc
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
            this.getData()
        },

        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.nik.toLowerCase() < b.nik.toLowerCase()) {
                        return -1
                    }
                    if (a.nik.toLowerCase() > b.nik.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.polaAbsensi.toLowerCase() < b.polaAbsensi.toLowerCase()) {
                        return -1
                    }
                    if (a.polaAbsensi.toLowerCase() > b.polaAbsensi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.wfh.toLowerCase() < b.wfh.toLowerCase()) {
                        return -1
                    }
                    if (a.wfh.toLowerCase() > b.wfh.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.wfo.toLowerCase() < b.wfo.toLowerCase()) {
                        return -1
                    }
                    if (a.wfo.toLowerCase() > b.wfo.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.mangkir.toLowerCase() < b.mangkir.toLowerCase()) {
                        return -1
                    }
                    if (a.mangkir.toLowerCase() > b.mangkir.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.dinas.toLowerCase() < b.dinas.toLowerCase()) {
                        return -1
                    }
                    if (a.dinas.toLowerCase() > b.dinas.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 7) {
                function compare(a,b) {
                    if (a.cuti.toLowerCase() < b.cuti.toLowerCase()) {
                        return -1
                    }
                    if (a.cuti.toLowerCase() > b.cuti.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 8) {
                function compare(a,b) {
                    if (a.sakit.toLowerCase() < b.sakit.toLowerCase()) {
                        return -1
                    }
                    if (a.sakit.toLowerCase() > b.sakit.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 9) {
                function compare(a,b) {
                    if (a.ijin.toLowerCase() < b.ijin.toLowerCase()) {
                        return -1
                    }
                    if (a.ijin.toLowerCase() > b.ijin.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 10) {
                function compare(a,b) {
                    if (a.nsi.toLowerCase() < b.nsi.toLowerCase()) {
                        return -1
                    }
                    if (a.nsi.toLowerCase() > b.nsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 11) {
                function compare(a,b) {
                    if (a.nso.toLowerCase() < b.nso.toLowerCase()) {
                        return -1
                    }
                    if (a.nso.toLowerCase() > b.nso.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 12) {
                function compare(a,b) {
                    if (a.telat.toLowerCase() < b.telat.toLowerCase()) {
                        return -1
                    }
                    if (a.telat.toLowerCase() > b.telat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 13) {
                function compare(a,b) {
                    if (a.cepet.toLowerCase() < b.cepet.toLowerCase()) {
                        return -1
                    }
                    if (a.cepet.toLowerCase() > b.cepet.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 14) {
                function compare(a,b) {
                    if (a.lembur.toLowerCase() < b.lembur.toLowerCase()) {
                        return -1
                    }
                    if (a.lembur.toLowerCase() > b.lembur.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 15) {
                function compare(a,b) {
                    if (a.hariKerjaKalender.toLowerCase() < b.hariKerjaKalender.toLowerCase()) {
                        return -1
                    }
                    if (a.hariKerjaKalender.toLowerCase() > b.hariKerjaKalender.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 16) {
                function compare(a,b) {
                    if (a.hariKerjaPegawai.toLowerCase() < b.hariKerjaPegawai.toLowerCase()) {
                        return -1
                    }
                    if (a.hariKerjaPegawai.toLowerCase() > b.hariKerjaPegawai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getDownload() {
            this.$store.state.loadingScreen = true
            let payload = {
                idPegawai: this.idPegawai,
                limit: this.totalRow,
                lvl: this.idUnits,
                namaKontrak: this.searchKontrak,
                pageIn: 1,
                tanggalMulai: this.tanggalMulai,
                tanggalSelesai: this.tanggalBerakhir
            }
            DataApi.post("pegawai/kontrak/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let downloads = response.data.data
                    let fileName = 'Daftar Kontrak Pegawai'
                    let data = [
                        {
                            sheet: fileName,
                            columns: [
                                { label: 'Nama', value: 'idPegawai'  },
                                { label: 'NIP', value: 'nik' },
                                { label: 'Jabatan', value: 'jabatan' },
                                { label: 'Bidang', value: 'bidang' },
                                { label: 'Judul Kontrak', value: 'judulKontrak' },
                                { label: 'Penempatan Wilayah', value: 'penemparanWilayah' },
                                { label: 'Nama Kontrak Pihak 1', value: 'namaKontrakPihak1'},
                                { label: 'Nomor Kontrak Pihak 1', value: 'nomorKontrakPihak1'},
                                { label: 'Tanggal Mulai Kontrak Pihak 1', value: 'tanggalMulaiKontrakPihak1'},
                                { label: 'Tanggal Berakhir Kontrak Pihak 1', value: 'tanggalSelesaiKontrakPihak1'},
                                { label: 'Nama Kontrak Pihak 2', value: 'namaKontrakPihak2'},
                                { label: 'Nomor Kontrak Pihak 2', value: 'nomorKontrakPihak2'},
                                { label: 'Tanggal Mulai Kontrak Pihak 2', value: 'tanggalMulaiKontrakPihak2'},
                                { label: 'Tanggal Berakhir Kontrak Pihak 2', value: 'tanggalSelesaiKontrakPihak2'},
                            ],
                            content: downloads
                        }
                    ]
                    let settings = {
                        fileName: fileName
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        },
        getData() {
            this.$store.state.loadingScreen = true
            this.flagSearch ? this.page = 1 : ''
            let payload = {
                limit: this.size,
                namaOrganisasi: this.searchKontrak,
                pageIn: this.page
            }
            DataApi.post("perusahaan_kontrak/get", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.errorMessage = response.message
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalRow = 0
                    this.totalPage = 1
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },

        editData(value) {
            this.flagSetting = true
            this.datasDetail.push(this.datas[value])
        },
        findData() {
            this.getData()
        },
        reload() {
            this.queryPegawai = ''
            this.queryUnit = ''
            this.idUnits = ''
            this.getDataPegawai()
            this.getDataUnit()
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
    }
}
</script>
<style scoped>
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.nowraps {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-title {
    font-size: 14px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    margin-right: 6px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    margin-right: 6px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
::v-deep .month-picker__container {
    z-index: 5 !important;
    width: 250px !important;
}
::v-deep .month-picker__year button {
    width: 50px;
    height: 48px;
}
::v-deep .month-picker-input {
    display: block;
    width: 100% !important;
    height: 36px !important;
    padding: .375rem .75rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    background-clip: padding-box;
    border: 1px solid;
    color: #768192;
    border-color: #d8dbe0;
    background-color: #f9fafc;
    border-radius: .25rem;
}
::v-deep .month-picker-input-container {
    width: 100% !important;
    height: 35px !important;
    min-width: none;
}
</style>